/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Dropdown_MacosInputs */

const en_downloads_dropdown_macos = /** @type {(inputs: Downloads_Dropdown_MacosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS`)
};

const es_downloads_dropdown_macos = /** @type {(inputs: Downloads_Dropdown_MacosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS`)
};

/**
* | output |
* | --- |
* | "macOS" |
*
* @param {Downloads_Dropdown_MacosInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_dropdown_macos = /** @type {((inputs?: Downloads_Dropdown_MacosInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Dropdown_MacosInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_dropdown_macos(inputs)
	return en_downloads_dropdown_macos(inputs)
});